import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'odq-tab-card',
    templateUrl: './tab-card.component.html',
    styleUrls: ['./tab-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TabCardComponent {

  @Input()
  title: string;

  @Input()
  addIcon = 'add_circle';

  @Input()
  addTitle = 'add';

  @Input()
  showHistoryActions = false;

  @Input()
  loading = false;

  @Output()
  addHistory = new EventEmitter<any>();

  addHistoryClicked() {
    this.addHistory.emit();
  }

}
